module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-16.08c7a5d6.jpg";